import { render, staticRenderFns } from "./MPArchiveView.vue?vue&type=template&id=9f228822&scoped=true&"
import script from "./MPArchiveView.vue?vue&type=script&lang=js&"
export * from "./MPArchiveView.vue?vue&type=script&lang=js&"
import style0 from "./MPArchiveView.vue?vue&type=style&index=0&id=9f228822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f228822",
  null
  
)

export default component.exports